import { toast } from 'react-toastify'

import {
  PestPacTimeoutExpirationStatus,
  PestPacTimeoutExpirationErrorMessage,
} from '@sales-center/common'

export function externalAppTimeoutError(payload: any): boolean {
  const code = payload?.StatusCode ?? payload?.status
  if (code === PestPacTimeoutExpirationStatus) {
    toast.error(PestPacTimeoutExpirationErrorMessage)
    return true
  }
  return false
}
